import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
var TableNodeView = /*#__PURE__*/_createClass(
/**
 * @constructor
 */
function TableNodeView(node, view, getPos, eventDispatcher) {
  _classCallCheck(this, TableNodeView);
  this.node = node;
  this.view = view;
  this.getPos = getPos;
  this.eventDispatcher = eventDispatcher;
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var _DOMSerializer$render = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)),
    dom = _DOMSerializer$render.dom,
    contentDOM = _DOMSerializer$render.contentDOM;
  this.dom = dom;
  this.contentDOM = contentDOM;
}

/**
 * Variables
 */);
export { TableNodeView as default };